<template lang="pug">
//- O mixin `tab` estiliza `.tab div`; com o scoping vira `.abas-vtal .tab div`, então o .tab
//- precisa ser filho da raiz, como no CashFlow.vue, e não a própria raiz.
.abas-vtal
  .tab.row
    router-link(tag="div" to="/funcionario/vtal" :class="{ active: ativa('/funcionario/vtal') }") USUÁRIOS VTEXP
    router-link(tag="div" to="/funcionario/vtal/pracas" :class="{ active: ativa('/funcionario/vtal/pracas') }") PRAÇAS
</template>

<script>
// Seletor de abas das telas do menu V.TAL: a mesma barra aparece no cadastro de login
// V.texp (Vtal.vue) e na manutenção de praças (PracasVtal.vue), sem item de menu novo.
export default {
  name: "AbasVtal",
  methods: {
    ativa(caminho) {
      return this.$route && this.$route.path === caminho
    },
  },
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.abas-vtal
  @include tab
  margin-top: 12px
  .tab div
    font-size: 13px
    letter-spacing: .4px
</style>
